import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  Input,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { styled } from "@mui/material/styles";
import { ArrowBack, CloudUpload } from "@mui/icons-material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import useMediaQuery from "@mui/material/useMediaQuery";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { useDispatch, useSelector } from "react-redux";
import { getFetchData, postData } from "../../store/reducers/Formapireducer";
import toast from "react-hot-toast";
import { LoadingButton } from "@mui/lab";
import {
  fileUpload,
  fnFileUpload,
  skillFileUpload,
} from "../../store/reducers/Imguploadreducer";
import store from "../..";

const CreateShowcase = () => {
  const navigate = useNavigate();

  //   FOR DROPDWON
  const [age, setAge] = useState("");
  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const location = useLocation();

  const dispatch = useDispatch();
  const params = useParams();

  const recID = params.id;
  const accessID = params.accessID;
  const screenName = params.screenName;
  const mode = params.Mode;
  const EmployeeID = params.parentID2;
  const AssessmentID = params.parentID1;

  const CompanyID = sessionStorage.getItem("compID");
  const state = location.state || {};

  const answerType = state.AnswerType;

  const Data = useSelector((state) => state.formApi.Data);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const isLoading = useSelector((state) => state.formApi.postLoading);
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID }));
  }, []);

  const StoryBoardSaveFn = async (values) => {
    let action = mode === "A" ? "insert" : "view";

    var isCheck = "N";
    if (values.Disable == true) {
      isCheck = "Y";
    }

    const idata = {
      RecordID: recID,
      EmplopyeeID: EmployeeID,
      AssessmentID: AssessmentID,
      Name: values.Name,
      Doctype: values.Doctype,
      Attachmentname: values.Attachmentname,
      Sortorder: values.Sortorder || "0",
      Disable: isCheck,
    };

    const response = await dispatch(postData({ accessID, action, idata }));
    if (response.payload.Status == "Y") {
      toast.success(response.payload.Msg);
      navigate(-1);
    } else {
      toast.error(response.payload.Msg ? response.payload.Msg : "Error");
    }
  };

  const fnLogOut = (props) => {
    Swal.fire({
      title: `Do you want ${props}?`,
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR026/Department");
        }
      } else {
        return;
      }
    });
  };

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const { toggleSidebar, broken, rtl } = useProSidebar();
  const initialValues = {
    Name: Data.Name || "",
    Doctype: Data.Doctype || "",
    Attachmentname: Data.Attachmentname || "",
    Sortorder: Data.Sortorder || "",
    Disable: Data.Disable == "Y" ? true : false,
  };

  const validationSchema = Yup.object({
    //Name: Yup.string().required("Please Enter Name Here"),
    Name: Yup.string().when("Doctype", {
      is: "Link",
      then: (schema) =>
        schema
          .required("Please enter a valid link")
          .url("Enter a valid URL (e.g. https://example.com)"),
      otherwise: (schema) => schema.required("Please Enter Name Here"),
    }),
    Doctype: Yup.string().required("Choose atleast one Document Type"),
    //Attachmentname: Yup.string().required("Choose at least one Document Type"),
    Attachmentname: Yup.string().when("Doctype", {
      is: (val) => val === "Pdf" || val === "Ppt",
      then: (schema) => schema.required("Please upload a file"),
      otherwise: (schema) => schema.nullable(),
    }),
    Sortorder: Yup.number().min(0, "No negative numbers").nullable(),
    //disable: Yup.boolean(),
  });
  return (
    <>
      <React.Fragment
        sx={{
          p: 2,
          height: "100vh",
        }}
      >
        {/* BREADCRUMBS */}
        <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
          <Box display="flex" justifyContent="space-between" p={2}>
            <Box display="flex" borderRadius="3px" alignItems="center">
              {broken && !rtl && (
                <IconButton onClick={() => toggleSidebar()}>
                  <MenuOutlinedIcon />
                </IconButton>
              )}
              <Box
                display={isNonMobile ? "flex" : "none"}
                borderRadius="3px"
                alignItems="center"
              >
                <Breadcrumbs
                  maxItems={3}
                  aria-label="breadcrumb"
                  separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
                >
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                    onClick={() =>
                      navigate("/Apps/TR290/List%20Of%20Assessment")
                    }
                  >
                    List Of Assessment Type({state.BreadCrumb1})
                  </Typography>
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                    onClick={() =>
                      navigate(`/Apps/Secondarylistview/skillglow/${params.accessID1}/${params.screenName}/${params.parentID3}`,
                        {
                         state: {...state}
                        }
                      )
                    }
                  >
                    List Of Assessment ({state.BreadCrumb2})
                  </Typography>
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                    onClick={() => navigate(-1)}
                  >
                    List Of Story Board
                  </Typography>
                  <Typography
                    variant="h5"
                    color="#0000D1"
                    sx={{ cursor: "default" }}
                  >
                    {mode == "A" ? "New" : "View"}
                  </Typography>
                </Breadcrumbs>
              </Box>
            </Box>

            <Box display="flex">
              <Tooltip title="Close">
                <IconButton onClick={() => fnLogOut("Close")} color="error">
                  <ResetTvIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Logout">
                <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                  <LogoutOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Paper>

        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={initialValues}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                StoryBoardSaveFn(values, resetForm);
              }, 100);
            }}
            enableReinitialize={true}
            validationSchema={validationSchema}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit,
              setFieldTouched,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                    gap: "10px",
                  }}
                >
                  {/* TEXTFIELD */}

                  <TextField
                    variant="standard"
                    type="text"
                    name="Name"
                    label={
                      <>
                        Name
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    }
                    id="Name"
                    //placeholder="Enter Your Description here......"
                    value={values.Name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    focused
                    error={!!touched.Name && !!errors.Name}
                    helperText={touched.Name && errors.Name}
                    sx={{
                      // backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#f5f5f5 ", // Ensure the filled variant also has a white background
                      },
                    }}
                    inputProps={{ readOnly: mode == "V" }}
                  />

                  {/* DROPDOWN */}

                  <FormControl
                    focused
                    variant="standard"
                    sx={{ background: "#ffffff" }}
                  >
                    <InputLabel id="Doctype">
                      <>
                        Document Type
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      </>
                    </InputLabel>
                    <Select
                      labelId="question-type-label"
                      // value={values.QType}
                      // onChange={handleChange}
                      label="Please Select Document Type"
                      name="Doctype"
                      id="Doctype"
                      required
                      value={values.Doctype}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      inputProps={{ readOnly: mode == "V" }}

                      // MenuProps={{
                      //   PaperProps: {
                      //     sx: {
                      //       mt: 1, // Add space so the top border doesn’t get cut
                      //     },
                      //   },
                      // }}
                    >
                      <MenuItem value="Pdf">Pdf</MenuItem>
                      <MenuItem value="Ppt">Ppt</MenuItem>
                      <MenuItem value="Link">Link</MenuItem>

                      {/* ✅ unique value */}
                    </Select>
                  </FormControl>

                  {/* SORT ORDER */}

                  <TextField
                    variant="standard"
                    name="Sortorder"
                    id="Sortorder"
                    type="number"
                    label="Sort Order"
                    value={values.Sortorder}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // error={!!touched.Sortorder && !!errors.Sortorder}
                    // helperText={touched.Sortorder && errors.Sortorder}
                    
                    sx={{ background: "" }}
                    focused
                    onWheel={(e) => e.target.blur()}
                    onInput={(e) => {
                      e.target.value = Math.max(0, parseInt(e.target.value))
                        .toString()
                        .slice(0, 8);
                    }}
                    InputProps={{
                      inputProps: {
                        style: { textAlign: "right" },
                        readOnly: mode == "V",
                      },
                    }}
                  />

                  {/* CHECKBOX */}

                  <FormControlLabel
                    control={
                      <Checkbox
                        name="Disable"
                        checked={values.Disable}
                        onChange={handleChange}
                        disabled={mode === "V"}
                      />
                    }
                    label="Disable"
                    sx={{
                      marginTop: "20px",
                      "@media (max-width:500px)": {
                        marginTop: 0,
                      },
                    }}
                  />
                </Box>
                {/* BUTTONS */}
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  padding={1}
                  gap={2}
                >
                  {values.Doctype !== "Link" && (
                    <React.Fragment>
                      <Tooltip title="Upload a file">
                        <IconButton
                          disabled={mode === "V"}
                          size="small"
                          color="primary"
                          aria-label="upload picture"
                          component="label"
                        >
                          <input
                            hidden
                            accept="all/*"
                            type="file"
                            onChange={(event) => {
                              const formData = new FormData();
                              formData.append("file", event.target.files[0]);
                              formData.append("type", "attachments");

                              dispatch(fileUpload({ formData: formData })).then(
                                (res) => {
                                  setFieldValue(
                                    "Attachmentname",
                                    res.payload.name
                                  );
                                }
                              );
                            }}
                          />
                          <CloudUpload fontSize="medium" />
                        </IconButton>
                      </Tooltip>
                      {(values.Doctype === "Pdf" ||
                        values.Doctype === "Ppt") && (
                        <span style={{ color: "red", fontSize: "20px" }}>
                          *
                        </span>
                      )}
                      {/* Show Yup validation error here */}
                      {touched.Attachmentname && errors.Attachmentname && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.8rem",
                            marginTop: "4px",
                          }}
                        >
                          {errors.Attachmentname}
                        </div>
                      )}
                      <Button
                        // disabled={mode === "V"}
                        variant="contained"
                        component={"a"}
                        onClick={() => {
                          var filePath =
                            store.getState().globalurl.attachmentSkillUrl +
                            values.Attachmentname;

                          if (values.Attachmentname) {
                            window.open(filePath, "_blank");
                          } else {
                            toast.error("Please Upload File");
                          }
                        }}
                      >
                        View
                      </Button>
                    </React.Fragment>
                  )}

                  <LoadingButton
                    type="submit"
                    variant="contained"
                    color={mode == "V" ? "error" : "secondary"}
                    loading={isLoading}
                    disabled={mode == "V" ? true : false}
                  >
                    Save
                  </LoadingButton>
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </Paper>
      </React.Fragment>
    </>
  );
};

export default CreateShowcase;
